import { useEffect } from 'react';

import { axiosClient } from '../../api/utils/provider';

import { useAuthQuery } from './useAuthQuery';

export const useCsrf = () => {
  const { userIdentity } = useAuthQuery();

  useEffect(() => {
    const requestInterceptor = axiosClient.interceptors.request.use((req) => {
      if (req.method !== 'get') {
        req.headers['X-CSRF-TOKEN'] = userIdentity?.requestForgeryProtectionToken;
      }

      return req;
    });

    // To avoid the infinity loop if the latter also receives the response code 401, we eject the interceptor in this case
    return () => {
      axiosClient.interceptors.request.eject(requestInterceptor);
    };
  }, [userIdentity?.requestForgeryProtectionToken]);
};
